import axios from "axios";
import { BenefisURL } from "../../../../config/UrlEndPoint";

export const URL = `${BenefisURL}benefis`;

// Get Benefis All For use Combobox data
export function getBenefisAll() {
  return axios.get(URL);
}

export function getBenefisAllNotFiltered() {
  return axios.get(`${URL}/not_filtered`);
}

// Get Benefis All For use Combobox data
export function getBenefisAllCompany() {
  return axios.get(`${URL}/allcompany`);
}

// //Get By ID
export function getBenefisById(benefisId) {
  return axios.get(`${URL}/${benefisId}`);
}

// items => filtered/sorted result for table data
export function findBenefis(queryParams) {
  return axios.post(`${URL}/find`, queryParams);
}

// POST => POST: Create the benefis on the server
export function createBenefis(benefis) {
  return axios.post(URL, benefis);
}

// UPDATE => PUT: update the benefis on the server
export function updateBenefis(benefis) {
  return axios.put(`${URL}/${benefis.uuid}`, benefis);
}

export function deleteBenefis(uuid) {
  return axios.delete(`${URL}/${uuid}`);
}

// Validation Api for Benefis Individu
export function validateDataInd(data) {
  return axios.post(`${URL}/validate_i`, data);
}

// Save Benefis Individu
export function saveBenefisDataIndividu(data) {
  return axios.post(`${URL}/save_i`, data);
}

// Validation Api for Benefis Organisasi
export function validateDataOrg(data){
  return axios.post(`${URL}/validate_o`, data);
}

// Save Benefis Organisasi
export function saveBenefisDataOrganisasi(data){
  return axios.post(`${URL}/save_o`, data);
}